import React, { useState, useEffect } from "react";
import axios from "axios";
import MuiButton from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../actions/user.actions";
import { Grid, Box, Typography } from "@mui/material";
import { Mainpagestyle } from "./Style";
import Educationcard from "../Home/Educationcard";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Basicdetailsclicked from "../../Assets/images/Basicdetailsclicked.png";
import basicdetails from "../../Assets/images/basicdetails.png";
import kycclicked from "../../Assets/images/kycclicked.png";
import kyc from "../../Assets/images/kyc.png";
import incomeclicked from "../../Assets/images/incomeclicked.png";
import income from "../../Assets/images/income.png";
import sanction from "../../Assets/images/sanction1.png";
import sanctionclicked from "../../Assets/images/sanctionclicked.png";
import tickicon from "../../Assets/images/tickicon.png";
import { jwtDecode } from "jwt-decode";
import styless from "./styles.module.css";
import * as moment from "moment";
import BasicDetails from "./Components/BasicDetails";
import WorkDetails from "./Components/WorkDetails";
import Sanctions from "./Components/Sanctions";
import axiosInstance from "../../helpers/axios";
import Kyc from "./Components/Kyc";
import Disbursed from "./Components/Disbursed";
import FinalMessage from "./Components/FinalMessage/FinalMessage";
import "./Applications.css";

function Applications() {
  const token = sessionStorage.getItem("token");
  const decode = jwtDecode(token);
  const [isImageClicked1, setIsImageClicked1] = useState(false);
  const [isImageClicked2, setIsImageClicked2] = useState(false);
  const [isImageClicked3, setIsImageClicked3] = useState(false);
  const [isImageClicked4, setIsImageClicked4] = useState(false);
  const [isImageClicked5, setIsImageClicked5] = useState(false);
  const [stage, setStage] = useState("");
  const [applicationData, setApplicationData] = useState({});
  const [loadingFibe, setLoadingFibe] = useState(false);
  const [applicationsDetails, setApplicationDetails] = React.useState([]);
  const [expanded, setExpanded] = React.useState(false);
  const [activeAccordionField, setActiveAccordionField] = useState({})
  const dispatch = useDispatch();

  const applicationState = useSelector(
    (state) => state?.GETAPPLICATIONS?.getApplicationsData
  );

  const urlApplications = `${process.env.REACT_APP_DASHBOARD_URL}/users/basic-info?searchField=${decode?.mobile}`;

  useEffect(() => {
    if (applicationState) {
      setApplicationDetails(applicationState?.data?.data);

      setTimeout(() => {
        const fibeApplication = applicationState?.data?.res?.filter(
          (item) =>
            item?.obj?.applicationProfile?.fundSourceCode === "FIB" &&
            item?.obj?.applicationProfile?.status !== "Dropped" &&
            item?.obj?.applicationProfile?.status !== "Rejected" &&
            item?.obj?.applicationProfile?.status !== "Disbursed"
        );
        //console.log(fibeApplication, "FIBE");
        if (fibeApplication && fibeApplication.length > 0) {
          setLoadingFibe(false);
          const url = `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/fibe-profile`;
          const data = {
            applicationId: fibeApplication[0]?.obj?.data?.applicationId,
            fundCode:
              fibeApplication[0]?.obj?.applicationProfile?.fundSourceCode,
          };
          axios
            .post(url, data, {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              },
            })
            .then((res) => {
              setLoadingFibe(true);

              if (res?.data?.data?.bitlyUrl) {
                window.open(res?.data?.data?.bitlyUrl, "_blank");
              } else {
                console.error("Invalid URL for KYC");
              }
            })
            .catch((error) => alert(error?.response?.data?.message));
        } else {
          setLoadingFibe(true);
        }
      }, 1000);
    } else {
      dispatch(userActions.getApplications(urlApplications, token));
    }
  }, [applicationState]);

  const getApplicationStage = async (id) => {
    try {
      const response = await axiosInstance(
        `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/stage?applicationId=${id}`
      );
      setStage(response?.data?.data?.stage);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    setActiveAccordionField({})
  };

  const handleApplicationData = async (userId, applicationId) => {
    try {
      const response = await axiosInstance(
        `${process.env.REACT_APP_DASHBOARD_URL}/summary/user?id=${userId}&applicationId=${applicationId}`
      );
      setApplicationData(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleNewApplicationCreation = () => {
    const body = {
      mobile: decode?.mobile,
      channelId: "2",
      flow: "pay-later",
      userId: decode?.userId,
      applicationId: applicationsDetails?.pop()?.applicationId,
    };
    const sendBody = btoa(JSON.stringify(body));
    window.open(
      `${process.env.REACT_APP_PAYLATER_FRONTEND}/pan-details/${sendBody}`,
      "_self"
    );
  };

  const handleAccordionFieldClick = (field) => {
    const applicationId = sessionStorage.getItem("appId")
    setActiveAccordionField(prev => ({...prev, [applicationId]: field}))
  }

  return (
    <>
      <Mainpagestyle>
        {loadingFibe ? (
          <Box my={3}>
            <MuiButton
              variant="outlined"
              endIcon={<AddIcon size="small" />}
              sx={{
                marginBottom: 3,
                border: "1px solid #D32028",
                color: "#D32028",
                fontFamily: "Outfit",
                textTransform: "none",
                "&:hover": { border: "1px solid #D32028" },
              }}
              onClick={handleNewApplicationCreation}
            >
              New Application
            </MuiButton>
            <Typography variant="body2" component="div" className="payment">
              <span
                style={{
                  fontFamily: "Outfit-Medium",
                  fontSize: "1em",
                  whiteSpace: "nowrap",
                  borderLeft: "4px solid #D32028",
                  paddingLeft: "5px",
                }}
              >
                Active Applications
              </span>
            </Typography>

            {applicationsDetails?.map((item, index) => {
              return (
                <>
                  {item && Object.keys(item).length !== 0 && (
                    <div className="loan-payment-crd1">
                      <Accordion
                        style={{
                          backgroundColor: "#FFF8F4",
                          width: "100%",
                          overflow: "auto",
                          padding: "0.2rem",
                        }}
                        onClick={() => {
                          sessionStorage.setItem("appId", item?.applicationId);
                          sessionStorage.setItem("userId", item?.userId);
                          sessionStorage.setItem("mobile", item?.mobile);
                          getApplicationStage(item?.applicationId);
                          handleApplicationData(
                            item?.userId,
                            item?.applicationId
                          );
                        }}
                        expanded={expanded === index}
                        onChange={handleChange(index)}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Grid
                            container
                            spacing={3}
                            style={{ alignItems: "center" }}
                          >
                            <Grid item xs={12} sm={6} md={6} lg={3}>
                              <Typography
                                variant="body2"
                                component="div"
                                className="Tuviksh1"
                              >
                                {item?.applicationId}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6} lg={4}>
                              <Typography
                                variant="body2"
                                component="div"
                                className="Program"
                              >
                                Start Date :{" "}
                                {item.appliedOn
                                  ? moment(item.appliedOn).format("DD MMM YY")
                                  : "-"}{" "}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={5}>
                              <Typography
                                variant="body2"
                                component="div"
                                className="Program"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div style={{ display: "flex" }}>
                                    <span
                                      style={{
                                        fontFamily: "Outfit-Medium",
                                      }}
                                    >
                                      Status:
                                    </span>
                                    <span
                                      style={{
                                        color:
                                          item?.status === "Disbursed"
                                            ? "#12B76A"
                                            : "#F8A31F",
                                        fontFamily: "Outfit-Medium",
                                        backgroundColor:
                                          item?.status === "Disbursed"
                                            ? "#ECFDF3"
                                            : "#FFF6E8",
                                        borderRadius:
                                          item?.status === "In Process"
                                            ? "16px"
                                            : "0px",
                                        padding: "0.2rem",
                                      }}
                                    >
                                      {item?.status}
                                    </span>
                                  </div>
                                </div>
                              </Typography>
                            </Grid>
                          </Grid>
                        </AccordionSummary>

                        <AccordionDetails style={{ overflow: "auto" }}>
                          <div
                            style={{
                              listStyleType: "none",
                              display: "flex",
                              flexDirection: "row",
                              width: "1050px",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <div
                                style={{
                                  fontWeight: "500",
                                  color: "black",
                                  cursor: "pointer",
                                  lineHeight: "20px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                                onClick={() =>
                                  handleAccordionFieldClick("basic-details")
                                }
                              >
                                <img
                                  style={{ height: "25px", width: "25px" }}
                                  src={
                                    isImageClicked1
                                      ? Basicdetailsclicked
                                      : basicdetails
                                  }
                                  alt="basicdetails"
                                />
                                {stage < 2 ? (
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      borderStyle: "solid",
                                      borderColor: "#F8A31F",
                                      borderRadius: "50%",
                                      height: "21px",
                                      width: "21px",
                                      alignSelf: "center",
                                    }}
                                  ></div>
                                ) : (
                                  <div style={{ marginTop: "10px" }}>
                                    <img
                                      style={{
                                        padding: "1px",
                                        borderStyle: "solid",
                                        borderColor: "#12B76A",
                                        borderRadius: "50%",
                                        height: "20px",
                                        width: "20px",
                                        alignSelf: "center",
                                        backgroundColor: "#12B76A",
                                      }}
                                      src={tickicon}
                                    />
                                  </div>
                                )}

                                <p
                                  style={{
                                    fontFamily: "Outfit-Medium",
                                    fontSize: "14px",
                                    color: isImageClicked1
                                      ? "#D32027"
                                      : "black",
                                    marginTop: "5px",
                                  }}
                                >
                                  Basic Details
                                </p>
                              </div>
                              {stage < 2 ? (
                                <div
                                  style={{
                                    borderBottom: "2px dashed #F8A31F",
                                    borderSpacing: "40px",
                                    alignSelf: "center",
                                    height: "2px",
                                    width: "120px",
                                    marginRight: "20px",
                                  }}
                                ></div>
                              ) : (
                                <div style={{ marginTop: "45px" }}>
                                  <div
                                    style={{
                                      alignSelf: "center",
                                      height: "2px",
                                      width: "120px",
                                      background: "#12B76A",
                                    }}
                                  ></div>
                                </div>
                              )}
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <div
                                style={{
                                  marginRight: "5px",
                                  fontWeight: "500",
                                  fontSize: "15px",
                                  color: "black",
                                  cursor: "pointer",
                                  lineHeight: "20px",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  if (
                                    !applicationData?.employmentType ||
                                    !applicationData?.instituteName ||
                                    stage < 4
                                  ){
                                  handleAccordionFieldClick("work-details")
                                  }
                                }}
                              >
                                <img
                                  style={{ height: "25px", width: "25px" }}
                                  src={isImageClicked2 ? incomeclicked : income}
                                  alt="income"
                                />
                                {!applicationData?.employmentType ||
                                !applicationData?.instituteName ||
                                !(stage >= 4) ? (
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      borderStyle: "solid",
                                      borderColor: "#F8A31F",
                                      borderRadius: "50%",
                                      height: "21px",
                                      width: "21px",
                                      alignSelf: "center",
                                    }}
                                  ></div>
                                ) : (
                                  <div style={{ marginTop: "10px" }}>
                                    <img
                                      style={{
                                        padding: "1px",
                                        borderStyle: "solid",
                                        borderColor: "#12B76A",
                                        borderRadius: "50%",
                                        height: "20px",
                                        width: "20px",
                                        alignSelf: "center",
                                        backgroundColor: "#12B76A",
                                      }}
                                      src={tickicon}
                                    />
                                  </div>
                                )}

                                <p
                                  style={{
                                    fontFamily: "Outfit-Medium",
                                    fontSize: "14px",
                                    marginTop: "5px",
                                    color: isImageClicked2
                                      ? "#D32027"
                                      : "black",
                                  }}
                                >
                                  Work Details
                                </p>
                              </div>
                              {!applicationData?.employmentType ||
                              !applicationData?.instituteName ||
                              !(stage >= 4) ? (
                                <div
                                  style={{
                                    borderBottom: "2px dashed #F8A31F",
                                    borderSpacing: "40px",
                                    alignSelf: "center",
                                    height: "2px",
                                    width: "120px",
                                    marginRight: "20px",
                                  }}
                                ></div>
                              ) : (
                                <div style={{ marginTop: "45px" }}>
                                  <div
                                    style={{
                                      alignSelf: "center",
                                      height: "2px",
                                      width: "120px",
                                      background: "#12B76A",
                                    }}
                                  ></div>
                                </div>
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div
                                style={{
                                  fontWeight: "500",
                                  fontSize: "15px",
                                  color: "black",
                                  cursor: "pointer",
                                  lineHeight: "20px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                                onClick={() => {
                                  if (stage >= 4) {
                                    handleAccordionFieldClick("sanction")
                                  }
                                }}
                              >
                                <img
                                  style={{ height: "25px", width: "25px" }}
                                  src={
                                    isImageClicked5 ? sanctionclicked : sanction
                                  }
                                  alt="sanction"
                                />
                                {!(stage >= 8) ? (
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      borderStyle: "solid",
                                      borderColor: "#F8A31F",
                                      borderRadius: "50%",
                                      height: "21px",
                                      width: "21px",
                                      alignSelf: "center",
                                    }}
                                  ></div>
                                ) : (
                                  <div style={{ marginTop: "10px" }}>
                                    <img
                                      style={{
                                        padding: "1px",
                                        borderStyle: "solid",
                                        borderColor: "#12B76A",
                                        borderRadius: "50%",
                                        height: "20px",
                                        width: "20px",
                                        alignSelf: "center",
                                        backgroundColor: "#12B76A",
                                      }}
                                      src={tickicon}
                                    />
                                  </div>
                                )}
                                <p
                                  style={{
                                    fontFamily: "Outfit-Medium",
                                    fontSize: "14px",
                                    marginTop: "5px",
                                    color: isImageClicked3
                                      ? "#D32027"
                                      : "black",
                                  }}
                                >
                                  Sanction
                                </p>
                              </div>
                            </div>
                            {item?.obj?.applicationProfile?.fundSourceCode !==
                            "FIB" ? (
                              <>
                                {!(stage >= 8) ? (
                                  <div
                                    style={{
                                      borderBottom: "2px dashed #F8A31F",
                                      borderSpacing: "40px",
                                      alignSelf: "center",
                                      height: "2px",
                                      width: "120px",
                                      marginRight: "20px",
                                    }}
                                  ></div>
                                ) : (
                                  <div
                                    style={{
                                      alignSelf: "center",
                                      height: "2px",
                                      width: "120px",
                                      background: "#12B76A",
                                    }}
                                  ></div>
                                )}

                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontWeight: "500",
                                      fontSize: "15px",
                                      color: "black",
                                      cursor: "pointer",
                                      lineHeight: "20px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      textAlign: "center",
                                    }}
                                    onClick={() => {
                                      if (stage >= 8 && stage < 15) {
                                        handleAccordionFieldClick("kyc")
                                      }
                                    }}
                                  >
                                    <img
                                      style={{
                                        height: "25px",
                                        width: "25px",
                                      }}
                                      src={isImageClicked3 ? kycclicked : kyc}
                                      alt="kyc"
                                    />
                                    {!(stage >= 15) ? (
                                      <div
                                        style={{
                                          marginTop: "10px",
                                          borderStyle: "solid",
                                          borderColor: "#F8A31F",
                                          borderRadius: "50%",
                                          height: "21px",
                                          width: "21px",
                                          alignSelf: "center",
                                        }}
                                      ></div>
                                    ) : (
                                      <div style={{ marginTop: "10px" }}>
                                        <img
                                          style={{
                                            padding: "1px",
                                            borderStyle: "solid",
                                            borderColor: "#12B76A",
                                            borderRadius: "50%",
                                            height: "20px",
                                            width: "20px",
                                            alignSelf: "center",
                                            backgroundColor: "#12B76A",
                                          }}
                                          src={tickicon}
                                        />
                                      </div>
                                    )}
                                    <p
                                      style={{
                                        fontFamily: "Outfit-Medium",
                                        fontSize: "14px",
                                        marginTop: "5px",
                                        color: isImageClicked4
                                          ? "#D32027"
                                          : "black",
                                      }}
                                    >
                                      KYC
                                    </p>
                                  </div>
                                </div>
                              </>
                            ) : null}

                            {!(stage >= 15) ? (
                              <div
                                style={{
                                  borderBottom: "2px dashed #F8A31F",
                                  borderSpacing: "40px",
                                  alignSelf: "center",
                                  height: "2px",
                                  width: "120px",
                                  marginRight: "20px",
                                }}
                              ></div>
                            ) : (
                              <div
                                style={{
                                  alignSelf: "center",
                                  height: "2px",
                                  width: "120px",
                                  background: "#12B76A",
                                }}
                              ></div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div
                                style={{
                                  fontWeight: "500",
                                  fontSize: "15px",
                                  color: "black",
                                  cursor: "pointer",
                                  lineHeight: "20px",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  if (stage >= 15)
                                    handleAccordionFieldClick("disbursment")
                                }}
                              >
                                <img
                                  style={{ height: "25px", width: "25px" }}
                                  src={
                                    isImageClicked5 ? sanctionclicked : sanction
                                  }
                                  alt="disbursal"
                                />
                                {!stage <= 15 && !(stage === 17) ? (
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      borderStyle: "solid",
                                      borderColor: "#F8A31F",
                                      borderRadius: "50%",
                                      height: "21px",
                                      width: "21px",
                                      alignSelf: "center",
                                    }}
                                  ></div>
                                ) : (
                                  <div style={{ marginTop: "10px" }}>
                                    <img
                                      style={{
                                        padding: "1px",
                                        borderStyle: "solid",
                                        borderColor: "#12B76A",
                                        borderRadius: "50%",
                                        height: "20px",
                                        width: "20px",
                                        alignSelf: "center",
                                        backgroundColor: "#12B76A",
                                      }}
                                      src={tickicon}
                                    />
                                  </div>
                                )}
                                <p
                                  style={{
                                    fontFamily: "Outfit-Medium",
                                    fontSize: "14px",
                                    marginTop: "5px",
                                    color: isImageClicked5
                                      ? "#D32027"
                                      : "black",
                                  }}
                                >
                                  Disbursment
                                </p>
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                        {activeAccordionField[item?.applicationId] === "basic-details" && (
                          <BasicDetails application={applicationData} />
                        )}
                        {activeAccordionField[item?.applicationId] === "work-details" && (
                          <WorkDetails
                            application={applicationData}
                            stage={stage}
                          />
                        )}
                        {activeAccordionField[item?.applicationId] === "sanction" && (
                          <Sanctions
                            application={applicationData}
                            stage={stage}
                          />
                        )}
                        {activeAccordionField[item?.applicationId] === "kyc" && (
                          <Kyc application={applicationData} stage={stage} />
                        )}
                        {activeAccordionField[item?.applicationId] === "disbursment" && (
                          <Disbursed item={item} stage={stage} />
                        )}
                        {stage === 17 && <FinalMessage />}
                      </Accordion>
                    </div>
                  )}
                </>
              );
            })}
          </Box>
        ) : (
          <Box>
            <div>
              <h1
                style={{
                  textAlign: "center",
                  fontFamily: "Outfit",
                  color: "#d32028",
                  padding: "1rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  gap: "2rem",
                }}
              >
                Loading
                <div
                  className={styless.dotFlashing}
                  style={{
                    marginBottom: "0.5rem",
                  }}
                ></div>
              </h1>
            </div>
          </Box>
        )}
      </Mainpagestyle>
      <Educationcard
        application={applicationsDetails?.slice(-1)[0]}
        newUser={applicationsDetails?.length === 1}
        mobile={decode?.mobile}
      />
    </>
  );
}

export default Applications;
